<template>
  <div class="container">
    <div class="row">
      <div v-if="description" class="col" v-html="description"></div>
      <div class="row" v-for="question in questions" :key="question.id">
        <!-- TODO: select on click on any of the content: -->
        <!-- v-on:click="$refs[`radio-${question.id}-${index}`].checked=true;" -->
        <div
          class="col form-check d-flex flex-column"
          v-for="(choice, index) in question.choices"
          :key="question.id * 100 + index"
        >
          <div class="row py-1">
            <div class="col form-check-inline d-flex justify-content-around">
              <input
                type="radio"
                class="form-check-input rich-choice-horizontal"
                :id="`radio-${question.id}-${index}`"
                :name="`radio-group-${question.id}`"
                v-model="question.response"
                :value="choice.value"
                v-on:change="handleInputCompleted"
                :ref="`radio-${question.id}-${index}`"
              />
            </div>
          </div>
          <div
            :class="[
              'row',
              'flex-grow-1',
              index + 1 < question.choices.length ? 'vertical-separator' : '',
            ]"
          >
            <div class="col">
              <label
                class="form-check-label w-100 text-center"
                :for="`radio-${question.id}-${index}`"
              >
                <b>
                  <u>
                    {{ choice.display.label }}
                  </u>
                </b>
              </label>
              <div class="my-3" v-html="choice.display.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RichChoiceHorizontal'
}
</script>
